<template>
  <SubContent @back="goback">
    <template v-slot:nav_left>
      {{teaching.title}}
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="tutorial_info">
          <div class="info">
            <div><span>分类/{{teaching.categoryZh}}</span><span v-show="teaching.skillLevelZh">技术等级/{{teaching.skillLevelZh}}</span>
            </div>
            <div>最后更新时间/{{teaching.updatedAt | time(true)}}</div>
            <div class="icon_wrap">
<!--              <img-->
<!--                v-if="!start"-->
<!--                src="@/assets/images/common/star.png"-->
<!--                title="收藏"-->
<!--                @click="startTutorial">-->
<!--              <img-->
<!--                v-if="start"-->
<!--                src="@/assets/images/common/star_copy.png"-->
<!--                title="取消收藏"-->
<!--                @click="startTutorial">-->
              <img
                v-if="!thumb"
                src="@/assets/images/common/thumb.png"
                title="点赞"
                style="margin-right:0"
                @click="thumbTutorial">
              <img
                v-if="thumb"
                src="@/assets/images/common/thumb_copy.png"
                title="点赞"
                style="margin-right:0"
                @click="thumbTutorial">
              <span style="margin-right:25px">({{recommendNumber}})</span>
              <div v-if="teaching.owner  && !teaching.finishEvent" class="mine">
<!--                <a-->
<!--                  v-show="false"-->
<!--                  ref="download_btn"-->
<!--                  :href="pdf_url"-->
<!--                  :download="pdf_name"></a>-->
<!--                <img src="@/assets/images/common/down.png" :title="$t('downloadPlan')" @click="downTutorial">-->
                <img src="@/assets/images/common/edit.png" title="编辑比赛" @click="editTutorial">
<!--                <img src="@/assets/images/common/remove.png" :title="$t('removePlan')" @click="showTip = true">-->
                {{$t('sharedPermission')}}
                <select v-model="sharingStatus" class="select" @change="updateSharingStatus">
                  <option value="Club">内部可看</option>
                  <option value="Private">仅个人可看</option>
                </select>
              </div>
            </div>
          </div>
          <div class="user">
            <img :src="teaching.authorHeadImgUrl ? teaching.authorHeadImgUrl : person" alt=""
                 @error="teaching.authorHeadImgUrl = person">
            <div>
              <p class="name">{{teaching.authorName}}</p>
              <p>{{$t('professionalFootballCoach')}}</p>
            </div>
          </div>
        </div>
        <div class="typeLink">
          <p class="link" :class="typeLink==='links' ? 'active' : 'hover'" @click="changeTypeLink('links')">比赛环节</p>
          <p
            class="link"
            :class="typeLink==='team' ? 'active' : 'hover'"
            style="margin-left: 20px"
            @click="changeTypeLink('team')">团队列表</p>
        </div>
        <template v-if="typeLink === 'links'">
          <div v-if="teaching.overallDescription" class="description">
            <p>{{$t('generalDescription')}}：</p>
            <div v-html="teaching.overallDescription"></div>
          </div>
          <div class="tutorial_wrap">
            <div class="left">
              <div class="title">
                <div><span class="name">{{detail.drillTitle}}</span></div>
                <div class="time">{{detail.timeSpent || "--" }}分钟</div>
              </div>
              <div class="flashWrap">
                <div class="down">
                  <div v-if="flashFlag" class="flash">
                    <template v-for="(item, index) in linkList">
                      <object
                        v-if="idx === index"
                        id=""
                        :key="item.id"
                        type="application/x-shockwave-flash"
                        name="sspviewer"
                        align="middle"
                        :data="`${HOSTURL}/uploads/flash-tool/yioks-football-view.swf?revision=1463`"
                        width="589"
                        height="343">
                        <param name="quality" value="high">
                        <param name="bgcolor" value="#000000">
                        <param name="play" value="false">
                        <param name="loop" value="false">
                        <param name="wmode" value="transparent">
                        <param name="scale" value="showall">
                        <param name="menu" value="true">
                        <param name="devicefont" value="false">
                        <param name="salign" value="">
                        <param name="allowscriptaccess" value="sameDomain">
                        <param name="allowfullscreen" value="true">
                        <param name="flashvars"
                               :value="`xmlRequestFile=/api/editor/myXmlView?sessionUuid=${sessionUuid}&screenSortOrder=${idx}`">
                      </object>
                    </template>
                  </div>
                  <img class="placeholder_img" :src="detail.coverImgUrl" @error="detail.coverImgUrl = placeHolderImg">
                </div>
                <div v-if="!flashFlag" class="flashTipsImg">
                  <a href="https://get2.adobe.com/cn/flashplayer/" style="">
                    <img :src="FlashTips" alt="">
                  </a>
                </div>
                <div class="flashLines">
                  <div v-if="lineList.length" class="lines_key"
                       :style='"background: url(" + Grass + ") top left repeat;"'>
                    <div class="key block">
                      <div v-for="(item, index) in lineList" :key="index" class="col">
                        <div class="line_container block" :style='"border-color:"+item._lineColor+""'>
                          <img
                            :src='"@/assets/images/arrows/arrow_left_"+ item._arrowThickness_left +".png"'
                            width="15"
                            height="20"
                            alt="Arrow Large"
                            style="position:absolute; top:0px; left:0px;"/>
                          <img
                            :src='"@/assets/images/lines/line_"+item._lineStyle+"_"+item._lineType+"_"+item._lineThickness+".png"'
                            width="50"
                            height="20"
                            alt="Line Straight 2px"
                            style="position:absolute; top:-0px; left:15px;"/>
                          <img
                            :src='"@/assets/images/arrows/arrow_right_"+item._arrowThickness_right +".png"'
                            width="15"
                            height="20"
                            alt="Arrow Medium Right"
                            style="position:absolute; top:-0px; left:65px;"/>
                        </div>
                        <p class="drill">{{item.name_zh}}</p>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="linkDescription">
                <div class="link_title">
                  <p :class="{active: isLink}"  @click="showLinkTime(true)">环节描述</p>
                  <p
                    v-if="linkTimeList.length > 0 "
                    :class="{active: !isLink}"
                    style="margin-left: 20px"
                    @click="showLinkTime(false)">活动周期</p>
                </div>
                <div v-if="detail.drillComment" class="link_content" v-html="detail.drillComment"></div>
                <div v-if="linkTimeList.length > 0 && !isLink" class="link_content">
                  <div>
                    <div class="tr">
                      <div class="time col">
                        <p>时间</p>
                      </div>
                      <div class="number col">
                        <p>号码</p>
                      </div>
                      <div class="name col">
                        <p>球员姓名</p>
                      </div>
                      <div class="squad col">
                        <p>球队</p>
                      </div>
                      <div class="status ">
                        <p>状态</p>
                      </div>
                    </div>
                    <div v-for="item in linkTimeList" :key="item.id" class="td">
                      <div class="time col">
                        <p>{{filterTime(parseInt(item._time / 60))}}:{{ filterTime(item._time % 60)}}</p>
                      </div>
                      <div class="number col">
                        <p>{{item.id || '--'}}</p>
                      </div>
                      <div class="name col">
                        <p v-if="item._teamPlayerId">{{filterPlayer(item._teamPlayerId, 1)}}</p>
                        <p v-else>{{filterPlayer(item._nonprTeamPlayerId)}}</p>
                      </div>
                      <div class="squad col">
                        <p>{{item._teamPlayerId ? '主队' : '客队'}}</p>
                      </div>
                      <div class="status">
                        <p>{{item._activityCode | competitionStatus}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <p>{{$t('allLinks')}}</p>
              <p
                v-for="(item, index) in linkList"
                :key="index"
                class="link"
                :class="idx === index ?'active':'hover' "
                @click="idx = index">{{item.drillTitle}}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="teamPlayers">
            <div class="teamList">
              <div class="title">
                <img :src="zhu" alt="">
                <h4>{{teaching._teamWePlay === 'Home' ? teaching._teamNameOurs : teaching._teamNameOpposition}}</h4>
                <span>(主场)</span>
              </div>
              <div class="tr">
                <div class="clothNumber">
                  <strong>球衣号</strong>
                </div>
                <div class="name">
                  <strong>姓名</strong>
                </div>
                <div class="position">
                  <strong>位置</strong>
                </div>
                <div class="enterBall">
                  <strong>进球</strong>
                </div>
                <div class="time">
                  <strong>比赛时长(min)</strong>
                </div>
              </div>
              <div
                v-for="item in teaching.tacticalTeamPlayersVo"
                :key="item.id"
                class="tr"
              >
                <p class="clothNumber">
                  <span class="number">{{item._playerNumber}}</span>
                </p>
                <p class="name">{{item.idName}}</p>
                <p class="position">{{item._playerPositionId | positionStatus}}</p>
                <p class="enterBall">{{item.goals }}</p>
                <p class="time">{{parseInt(item.matchSecond / 60)}}</p>
              </div>
            </div>
            <div class="teamList" style="margin-left: 15px">
              <div class="title">
                <img :src="ke" alt="">
                <h4>{{teaching._teamWePlay === 'Home' ? teaching._teamNameOpposition : teaching._teamNameOurs}}</h4>
                <span>(客场)</span>
                </div>
              <div class="tr">
                <div class="clothNumber">
                  <strong>球衣号</strong>
                </div>
                <div class="name">
                  <strong>姓名</strong>
                </div>
                <div class="position">
                  <strong>位置</strong>
                </div>
                <div class="enterBall">
                  <strong>进球</strong>
                </div>
                <div class="time">
                  <strong>比赛时长(min)</strong>
                </div>
              </div>
              <div
                v-for="item in teaching.tacticalNonprTeamPlayers"
                :key="item.id"
                class="tr"
              >
                <p class="clothNumber">
                  <span class="number" style="">{{item._playerNumber}}</span>
                </p>
                <p class="name">{{item._familyName}}</p>
                <p class="position">{{item._playerPositionId | positionStatus}}</p>
                <p class="enterBall">{{item.goals }}</p>
                <p class="time">{{parseInt(item.matchSecond / 60)}}</p>
              </div>
            </div>
          </div>
        </template>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
      <yioks-tip :showTip="showTip" :tipMsg="$t('deleteTeachingPlanTips')" @callback='delTutorial'/>
    </div>
  </SubContent>
</template>
<script>
import teaching from '@/api/teaching'
import person from '@/assets/images/common/person.jpg'
import zhu from '@/assets/images/common/zhu.png'
import ke from '@/assets/images/common/ke.png'
import Grass from '@/assets/images/common/grass.gif'
import FlashTips from '@/assets/images/common/flash_tips.png'
import placeHolderImg from '@/assets/images/common/plan_default_big.jpg'
import {flashCheck, positionStatus, competitionStatus} from '@/utils/yioks_filter'
import tutorial from '@/api/tutorial'
import storage from '@/utils/storage'

export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    positionStatus,
    competitionStatus
  },
  data () {
    return {
      FlashTips,
      zhu,
      ke,
      Grass,
      placeHolderImg,
      person,
      userRole: storage.get('userInfo').userRole,
      copyShow: ['coach'],
      start: false,
      thumb: false,
      pdf_url: '',
      pdf_name: '',
      idx: 0,
      lineList: [], // 教案中线条
      flashFlag: false, // 是否允许flash
      sessionUuid: this.$route.query.uuid || 'a27d54e00bbd42bba9577cbf23baa61e', // 教案的uuid
      tutorial: {}, // 教案详情
      linkList: [], // 所有环节
      detail: [],
      loading: true,
      HOSTURL: process.env.VUE_APP_URL,
      sharingStatus: 'Club',
      recommendNumber: 0,
      navIdx: this.$route.query.idx ? this.$route.query.idx : 0,
      showTip: false,
      teaching: {},
      typeLink: 'links', // 环节 还是 团队
      isLink: true, // 活动周期还是 环节,
      linkTimeList: []
    }
  },
  watch: {
    idx (val) {
      this.detail = this.linkList[val]
      const list = this.linkList[val].screenPrMinutesList.concat(this.linkList[val].screenSessionMinutesList)
      if (list.length > 0) {
        let idx
        for (let i = 0; i < list.length; i++) {
          if (list[i]._activityCode === 'start_play') {
            idx = i
            break
          }
        }
        if (idx) {
          const first = list[idx]
          const arr1 = [].concat(list)
          arr1.splice(idx, 1)
          arr1.sort((a, b) => {
            return a._time - b._time
          })
          this.linkTimeList = [first].concat(arr1)
        } else {
          this.linkTimeList = list.sort((a, b) => {
            return a._time - b._time
          })
        }
      } else {
        this.linkTimeList = []
      }

      // this.linkTimeList = this.linkList[val].screenPrMinutesList.concat(this.linkList[val].screenSessionMinutesList).sort((a, b) => { return a._time - b._time })
    }
  },
  created () {
    teaching.getMatchTeachingDetail({
      sessionUuid: this.sessionUuid
    }).then(res => {
      this.loading = false
      this.teaching = res
      this.linkList = res.planTacticalDrills
      this.detail = res.planTacticalDrills[0]
      // this.linkTimeList = res.planTacticalDrills[0].screenPrMinutesList.concat(res.planTacticalDrills[0].screenSessionMinutesList).sort((a, b) => { return a._time - b._time })
      const list = res.planTacticalDrills[0].screenPrMinutesList.concat(res.planTacticalDrills[0].screenSessionMinutesList)
      let idx
      for (let i = 0; i < list.length; i++) {
        if (list[i]._activityCode === 'start_play') {
          idx = i
          break
        }
      }
      if (idx) {
        const first = list[idx]
        const arr1 = [].concat(list)
        arr1.splice(idx, 1)
        arr1.sort((a, b) => {
          return a._time - b._time
        })
        this.linkTimeList = [first].concat(arr1)
      } else {
        this.linkTimeList = list.sort((a, b) => {
          return a._time - b._time
        })
      }
      // console.log([first].concat(arr1))
      this.lineList = res.planTacticalLineListVos
      this.start = res.favorite
      this.thumb = res.recommend
      this.recommendNumber = res.teachingExpand.recommendNumber
      this.sharingStatus = res.teachingExpand.sharingStatus
    })
  },
  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    filterPlayer(val, type) {
      let list = []
      let name = '--'
      if (type === 1) {
        list = this.teaching.tacticalTeamPlayersVo // 主队
        const nameObj = list.find(item => {
          return item._prPlayerId === val
        })
        if (nameObj) {
          name = nameObj.idName
        }
      } else {
        list = this.teaching.tacticalNonprTeamPlayers // 客队

        const nameObj = list.find(item => {
          return item._nonprPlayerId === val
        })
        if (nameObj) {
          name = nameObj._familyName
        }
      }
      return name
    },
    getDetail() {
      tutorial.getTutorialDetail({sessionUuid: this.sessionUuid}).then(res => {
        this.loading = false
        if (res.code === 'TeachingUuidInexistence') {
          this.$message.error('教案不存在')
          this.$router.push('/')
        } else {
          this.tutorial = res
          console.log(res)
          this.linkList = res.planTacticalDrills
          this.detail = res.planTacticalDrills[0]
          this.lineList = res.planTacticalLineListVos
          this.start = res.favorite
          this.thumb = res.recommend
          this.recommendNumber = res.teachingExpand.recommendNumber
          this.sharingStatus = res.teachingExpand.sharingStatus
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    startTutorial() {
      this.start = !this.start
      let requestName = tutorial.favoriteAdd
      if (!this.start) requestName = tutorial.favoriteRemove
      requestName({sessionUuid: this.sessionUuid}).then(res => {
        if (this.start) {
          this.$message.success('收藏成功')
        } else {
          this.$message.success('取消成功')
        }
      })
    },
    thumbTutorial() {
      if (this.thumb) return
      tutorial.recommendAdd({
        authorUserUuid: this.teaching.authorUserUuid,
        sessionUuid: this.sessionUuid
      }).then(res => {
        this.$message.success('点赞成功')
        this.thumb = true
        this.recommendNumber += 1
      })
    },
    goback() {
      this.$router.go(-1)
    },
    updateSharingStatus() {
      tutorial.updateSharingStatus({sessionUuid: this.sessionUuid, sharingStatus: this.sharingStatus}).then(res => {
        this.$message.success('修改成功')
      })
    },
    downTutorial() {
      tutorial.downloadTeachingPdf({sessionUuid: this.sessionUuid}).then(res => {
        if (res.fileName && res.filePath) {
          this.pdf_url = res.filePath
          this.pdf_name = res.fileName
          this.$nextTick(() => {
            this.$refs.download_btn.click()
          })
        }
      })
    },
    editTutorial () {
      this.$router.push({
        path: 'editMatchPlan',
        query: {
          uuid: this.sessionUuid,
          gotoUrl: 'teaching/detail?uuid=' + this.sessionUuid
        }
      })
    },
    delTutorial(isSure) {
      if (isSure) {
        tutorial.teachingRemove({sessionUuid: this.tutorial.uuid}).then(res => {
          this.goback()
          this.$message.success('删除成功')
        })
      } else {
        this.showTip = false
      }
    },
    changeTypeLink(val) {
      if (this.typeLink === val) return
      this.typeLink = val
    },
    showLinkTime(val) {
      if (this.isLink === val) return
      this.isLink = val
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .scroll_wrap
    flex 1
    overflow hidden
    padding 20px 0
    color #DDD

    .tutorial_info
      padding-top 10px
      /*padding-bottom 25px*/
      border-bottom 1px solid #FFF
      margin 0 30px
      display flex
      justify-content space-between

      .info
        div
          margin-bottom 20px

        span
          margin-right 30px

        .icon_wrap
          display flex
          align-items center

          .mine
            display flex
            align-items center
            margin-bottom 0

            .select
              margin-left 10px
              height 40px
              padding-left 10px

          img
            cursor pointer
            margin-right 25px

          span
            margin 0 0 0 10px

      .user
        display flex
        align-items center

        .name
          font-size 20px
          margin-bottom 30px
          min-width 115px

        img
          width 90px
          height 90px
          border-radius 90px
          margin-right 10px

    .typeLink
      display flex
      justify-content center

      &:last-child
        margin-left 20px

      .link
        color #FFF
        padding 10px 20px
        margin-top 15px
        border 2px solid transparent
        cursor pointer

        &.active
          background $green_color
        &.hover
          &:hover
            background url('~@/assets/images/common/hover_img.png') no-repeat right top
            box-shadow inset 0 0 12px #4cd964
            color #ddd
            border 2px solid #4cd964

    .teamPlayers
      display flex
      margin 0 30px
      justify-content center

      .teamList
        margin-top 15px
        width 390px
        .title
          display flex
          align-items center
          padding-bottom 10px
          border-bottom 1px solid white
          h4
            margin 0
            margin-left 10px
            font-size 20px
        .tr
          display flex
          align-items center
          padding 15px 0
          border-bottom 1px solid white
          p
            padding-right 5px
          .clothNumber
            width 20%

            .number
              border-radius: 50%;
              background-color: #4cd964;
              display: inline-block;
              width: 33px;
              height: 33px;
              text-align: center;
              line-height: 33px

          .name
            width 20%

          .position
            width 17%

          .enterBall
            width 15%

          .time
            width 28%

    .description
      padding 20px 0
      margin 0 30px
      border-bottom 1px solid #FFF
      line-height 22px

    .tutorial_wrap
      margin 15px 30px 0
      display flex

      .left
        flex 1
        padding-right 30px

        .title
          display flex
          justify-content space-between
          align-items center

          .name
            font-size 18px
            margin-right 30px

        .flashWrap
          margin-top 10px

          .down
            position relative
            min-height 343px

            .flash
              position relative
              z-index 2

            .placeholder_img
              width 595px
              height 343px
              position absolute
              top 0
              left 0
              z-index 1

          .flashTipsImg
            margin 10px 0
            width 226px
            heigth 29px

          .flashLines
            padding 10px 6px 0px 0px
            font-size 10px

            .lines_key
              margin-bottom 15px
              padding 10px 0 5px 0
              border 1px solid #386800
              height auto

              .col
                width 33%
                float left
                margin-bottom 5px
                display flex
                align-items center
                color #FFF

              .block
                display block

              .clear
                clear both
                display block
                overflow hidden
                visibility hidden
                width 0
                height 0

              .line_container
                float left
                width 80px
                height 0
                border-top 20px solid #FFF
                position relative
                margin-left 5px

              .line_container img
                display block
                background none
                float left
                margin-top -20px

              .drill
                position relative
                z-index 5

        .linkDescription
          .link_title
            display flex
            align-items center
            padding-bottom 15px
            border-bottom 1px solid white

            p
              cursor pointer

            .active
              color $green_color

          .link_content
            padding-top 20px
            padding-bottom 20px
            /*padding-bottom 40px*/

            .tr, .td
              display flex
              align-items center
              border-bottom 1px solid white
              height 40px
              line-height 40px
              border-right 1px solid white
              border-left 1px solid white

              .col
                border-right 1px solid white

                p
                  padding 0 5px
                  text-align center

              .time
                width 25%

              .number
                width 15%

              .name
                width 20%

              .squad
                width 25%

              .status
                width 15%

                p
                  text-align center

            .tr
              border-top 1px solid white

      .right
        border-left 1px solid #FFF
        padding 5px 0 0 20px
        font-size 18px
        min-width 180px

        .link
          color #FFF
          padding 10px 20px
          margin-top 15px
          border 2px solid transparent
          cursor pointer

          &.active
            background $green_color

          &.hover
            &:hover
              background url('~@/assets/images/common/hover_img.png') no-repeat right top
              box-shadow inset 0 0 12px #4cd964
              color #ddd
              border 2px solid #4cd964
</style>
